import { HTTP_HEADERS_PROPERTY } from '../api/apiConstants';

const RESPONSE_METADATA_MAP = new WeakMap();

export const getRrandFormResponse = response => {
    if (!response) {
        return;
    }
    return response?.headers?.get(HTTP_HEADERS_PROPERTY.RRAND);
};

export const getRrandFromData = data => {
    const headers = RESPONSE_METADATA_MAP.get(data);

    if (!headers) {
        return;
    }

    return getRrandFormResponse({ headers });
};

export const getDataWithResponseMetadata = (data, response) => {
    if (typeof data === 'object' && data !== null) {
        RESPONSE_METADATA_MAP.set(data, response?.headers);
    }

    return data;
};
